<template>
    <div class="user-privacy">
        <h2 class="user-privacy-title">用户协议</h2>
        <p class="user-privacy-content">
            请您在使用本产品之前仔细阅读下列条款。您下载、安装或使用产本品或者单击“同意”表明您已经阅读本协议并充分理解、遵守本协议所有条款，包括涉及免
            除或者限制本公司责任的免责条款、用户权利限制条款、约定争议解决方式等。 如果您不同意本协议的全部或部分内容，请取消下载、安装和使用本产品。
        </p>
        <p>1.权利声明</p>
        <p class="user-privacy-content">
            本公司提供的服务内容中所涉及的游戏，文字、软件、声音、图片、动画、录像、图表等，均受相关知识产权法以及其他相关法律的保护。未经本公司或者其
            他相关权利人授权，用户不得复制、使用、修改、摘编、翻译、发行,第三方未经本公司及/或其相关权利人的书面许可，不得以任何方式擅自进行使用。
        </p>
        <p>2.授权许可</p>
        <p class="user-privacy-content">
            用户理解并同意自行承担使用本服务的风险，且用户在使用本服务时，应遵循 中国法律的相关规定，由于用户行为所造成的任何损害和后果，本公司均不承担 除法律有明确规定外的责任。
        </p>
        <p>3．费用说明</p>
        <p class="user-privacy-content">
            我们的全部产品或服务都是是免费的，您需自行负担使用本产品过程中产生的相关费用，包括但不限于个人上网或第三方（包括但不限于电信或移动通讯提供商）收取的通讯费、信息费等相关费用。
        </p>
        <p>4．无担保声明</p>
        <p class="user-privacy-content">
            本公司在发布本产品之前，已尽可能对产品进行了详尽的技术测试和功能测试，但鉴于电子设备、操作系统、网络环境的复杂性，本公司不能保证本产品会兼容所有用户的电子设备，也无法保证用户在使用本产品过程中能够持续不出现任何技术故障。
        </p>
        <p>5．责任限制</p>
        <p class="user-privacy-content">用户在使用本产品时须遵守法律法规，不得利用本产品从事违法违规行为，包括但不限于：</p>
        <p class="user-privacy-content">1：发布、传送、传播、储存危害国家安全统一、破坏社会稳定、违反公序良俗、侮辱、诽谤、淫秽、暴力以及任何违反国家法律法规的内容；</p>
        <p class="user-privacy-content">2：发布、传送、传播、储存侵害他人知识产权、商业秘密等合法权利的内容；</p>
        <p class="user-privacy-content">3：恶意虚构事实、隐瞒真相以误导、欺骗他人，发布、传送、传播广告信息及垃圾信息；</p>
        <p class="user-privacy-content">4：其他法律法规禁止的行为。</p>
    </div>
</template>
<script>
export default {
    name: 'UserPrivacy'
};
</script>
<style scoped>
.user-privacy {
    padding: 50px;
    text-align: left;
}
.user-privacy-content {
    text-indent: 2em;
}
.user-privacy-title {
    text-align: center;
    margin-bottom: 40px;
}
</style>